var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.bannerImagesData != null)?_c('loop-play-images',{attrs:{"default-classes":_vm.defaultClasses,"images-data":_vm.bannerImagesData,"background-appe-mode":false}}):_vm._e(),_c('div',{staticClass:"rich-text",style:({minHeight: _vm.minHeight}),domProps:{"innerHTML":_vm._s(_vm.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }